// extracted by mini-css-extract-plugin
export var assigneeBadge = "_hm-0";
export var assigneeDetails = "_hm-1";
export var assigneeInfo = "_hm-2";
export var dropdownContainer = "_hm-4";
export var dropdownImage = "_hm-5";
export var editAssigneeInfo = "_hm-3";
export var editAssigneeModalContainer = "_hm-6";
export var hidden = "_hm-8";
export var input = "_hm-7";